"use client";

import { Droplet, Leaf, Sun } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AgencyBenefits() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const grid = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const pillars = [{
    icon: Leaf,
    eyebrow: "01",
    title: "Website Design",
    body: "We build high-converting, mobile-responsive websites tailored to your brand. Our designs focus on user experience and speed to keep your customers engaged."
  }, {
    icon: Sun,
    eyebrow: "02",
    title: "SEO Strategy",
    body: "Drive organic growth with data-driven SEO. We optimize your site structure and content to ensure you rank higher and attract qualified leads consistently."
  }, {
    icon: Droplet,
    eyebrow: "03",
    title: "Local SEO",
    body: "Dominate your local market. We specialize in resolving Google Business Profile suspensions and optimizing your local presence to get you found by nearby customers."
  }];
  return;
}